import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('wf_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Normalise error responses so callers can always render `error.message` as
// a string. Backend `detail` may be either a plain string OR a structured
// object (plan-enforcement 402s, validation errors, etc.). Rendering an
// object as a React child crashes the page — so we flatten it to a message
// string on every failed response.
client.interceptors.response.use(
  (r) => r,
  (err) => {
    const d = err?.response?.data?.detail;
    if (d && typeof d === 'object') {
      err.message = d.message || err.message || 'Request failed';
      err.planLimit = d.code === 'plan_limit_reached' ? d : null;
      err.code = d.code;
    } else if (typeof d === 'string' && d) {
      err.message = d;
    }
    return Promise.reject(err);
  },
);

export default client;
export { API_BASE };
